/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationsPayload } from '../models/NotificationsPayload';
import type { NotificationSummary } from '../models/NotificationSummary';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NotificationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Notification Preferences For Membership
     * @param membershipId
     * @returns NotificationsPayload Successful Response
     * @throws ApiError
     */
    public listNotificationPreferencesForMembership(
        membershipId: string,
    ): CancelablePromise<Record<string, NotificationsPayload>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/list-notification-preferences-for-membership/{membership_id}',
            path: {
                'membership_id': membershipId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Notification Preferences For Membership
     * @param membershipId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateNotificationPreferencesForMembership(
        membershipId: string,
        requestBody: Array<NotificationsPayload>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/notifications/update-notification-preferences-for-membership',
            query: {
                'membership_id': membershipId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Notification Preferences For Workflow
     * @param workflowId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateNotificationPreferencesForWorkflow(
        workflowId: string,
        requestBody: Array<NotificationsPayload>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/notifications/update-notification-preferences-for-workflow',
            query: {
                'workflow_id': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Notification Summaries For Membership
     * @param membershipId
     * @returns NotificationSummary Successful Response
     * @throws ApiError
     */
    public listNotificationSummariesForMembership(
        membershipId: string,
    ): CancelablePromise<Array<NotificationSummary>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/list-notification-summaries-for-membership/{membership_id}',
            path: {
                'membership_id': membershipId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Notification Preference By Membership Id By Workflow Id For Namespace
     * @param namespaceId
     * @returns NotificationsPayload Successful Response
     * @throws ApiError
     */
    public getNotificationPreferenceByMembershipIdByWorkflowIdForNamespace(
        namespaceId: string,
    ): CancelablePromise<Record<string, Record<string, NotificationsPayload>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/get-notification-preference-by-membership-id-by-workflow-id-for-namespace/{namespace_id}',
            path: {
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Notification Preference By Membership Id By Workflow Id For Entity
     * @param entityId
     * @returns NotificationsPayload Successful Response
     * @throws ApiError
     */
    public getNotificationPreferenceByMembershipIdByWorkflowIdForEntity(
        entityId: string,
    ): CancelablePromise<Record<string, Record<string, NotificationsPayload>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/get-notification-preference-by-membership-id-by-workflow-id-for-entity/{entity_id}',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
